import loadable from '@loadable/component';

export const BannerLoadable = loadable(
  () => import('@wix/payment-methods-banner/demo'),
  { resolveComponent: (module) => module.PaymentMethodsBannerDemo },
);
